import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { StepsProvider } from "react-step-builder";
import { store } from "../components/checkout/store";
import NavMenu from "../components/checkout/components/Cart/NavMenu";
import SideBar from "../components/checkout/components/Cart/SideBar";
import "../styles/checkout/main.scss";

/**
 *
 * @return {JSX.Element} - Cart page
 */
const CartMenu = () => {
  return (
    <Suspense fallback={<div className="loader"></div>} className="main-container">
      <Provider store={store}>
        <NavMenu />
      </Provider>
    </Suspense>
  );
};

/**
 * @return {JSX.Element} - Cart side bar
 * @returns {Element}
 * @constructor
 */
const CartSideBar = () => {
  return (
    <Suspense fallback={<div className="loader"></div>} className="main-container">
      <Provider store={store}>
        <StepsProvider>
          <SideBar />
        </StepsProvider>
      </Provider>
    </Suspense>
  );
};

/**
 * Attach app to the DOM
 */
const domNodeCart = document.querySelector("#custom-cart");
const domNodeCart2 = document.querySelector("#cart-sidebar");
const domNodeCart3 = document.querySelector("#cart-mobile");

const domNodeCartSideBar = document.querySelector("#cart-menu");

if (domNodeCart) {
  const rootCart = createRoot(domNodeCart);
  rootCart.render(<CartMenu />);
}

if(domNodeCart2) {
  const rootCart2 = createRoot(domNodeCart2);
  rootCart2.render(<CartMenu />);
}

if(domNodeCart3) {
  const rootCart3 = createRoot(domNodeCart3);
  rootCart3.render(<CartMenu />);
}

if (domNodeCartSideBar) {
  const rootCartSideBar = createRoot(domNodeCartSideBar);
  rootCartSideBar.render(<CartSideBar />);
}
